import { gql } from "@apollo/client";

const GET_ADJUNTOS_CAPA = gql`
query archivosCapa ( $idGestionCapa: Int!) {
    archivosCapa( idGestionCapa: $idGestionCapa ){
        idDocumentoCapa
        idGestionCapa
        idUsuarioAlta
        fechaAlta
        titulo
        extension
        archivo
        contentType
        fechaAlta
        usuarioNombre
    }
}
`;
export default GET_ADJUNTOS_CAPA;

export const adaptAdjuntosCapaArray = (capas) => {
  return structuredClone(capas)?.map((capa) => adaptAdjuntoCapa(capa));
};
const adaptAdjuntoCapa = (capa) => {
  return {
    idArchivo: capa?.idDocumentoCapa,
    idGestionCapa: capa?.idGestionCapa,
    idUsuario: capa?.idUsuarioAlta,
    usuario: capa?.usuarioNombre,
    fechaAlta: capa?.fechaAlta,
    titulo: capa?.titulo,
    extension: capa?.extension,
    archivo: capa?.archivo,
    contentType: capa?.contentType
  };
};